import { Image, Stack, Text } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";

import { getAssetUrl } from "@utils/getAssetUrl";
import { useLocale } from "@/apps/@components";
import { CampaignButton } from "../components";
import { logWallpaperEvent, logWallpaperPage } from "../wallpaperLog";
import { getStoredFrom } from "../wallpaperParams";
import { useEffect } from "react";
import { WALLPAPERS } from "../wallpapers";

export default function WallpaperHomePage() {
	const { t, locale } = useLocale();
	const navigate = useNavigate();
	// 帶著 search（?lang=en）進下一步，語系才不會在流程中掉回預設中文
	const { search } = useLocation();

	const langSuffix = locale === "en" ? "?lang=en" : "";

  useEffect(() => {
    logWallpaperPage({
      path: `/wallpaper/design_intro${langSuffix}`,
      from: getStoredFrom(),
    })
  }, [])

  useEffect(() => {
    const preload = () => {
      WALLPAPERS.forEach((w) => {
        // 注意：Image 名稱被 @mantine/core 佔用，這裡用 window.Image 建原生圖片物件
        const img = new window.Image();
        img.decoding = "async";
        (
          img as HTMLImageElement & { fetchPriority?: "high" | "low" | "auto" }
        ).fetchPriority = "low";
        img.src = w.src;
      });
    };

    const ric = window.requestIdleCallback;
    if (ric) {
      const id = ric(preload, { timeout: 3000 });
      return () => window.cancelIdleCallback?.(id);
    }
    // 不支援 requestIdleCallback（部分 Safari）→ 延遲一小段再載，讓首頁先載
    const timer = window.setTimeout(preload, 1500);
    return () => window.clearTimeout(timer);
  }, [])

	return (
		<Stack
			h="100svh"
			w="100%"
			gap={0}
			style={{
				backgroundImage: `url(${getAssetUrl(
					"/images/campaign-wallpaper/home-bg.webp",
				)})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
			p="7.6vw"
			align="center"
			pos="relative"
		>
			<Image
				src={getAssetUrl("/images/campaign-wallpaper/logo-white.svg")}
				alt="wallpaper-home"
				w="48.8vw"
			/>
			<Stack
				gap="12.7vw"
				pos="absolute"
				bottom="18.7vw"
				left="50%"
				style={{ transform: "translateX(-50%)" }}
			>
				<Text
					size="4.5vw"
					c="#fff"
					fw={900}
					lh="normal"
					ta="center"
					style={{ flexShrink: 0, whiteSpace: "pre-wrap" , letterSpacing: locale === "en" ? "0.02em" : "0.1em"}}
				>
					{t("home.title")}
				</Text>
				<CampaignButton
					w="51.3vw"
					color="#fff"
					style={{ borderWidth: "1px", letterSpacing: locale === "en" ? "0.06em" : "0.2em"}}
          fz={locale === "en" ? "3.3vw" : "4vw"}
					onClick={() => {
						logWallpaperEvent({
							path: `/wallpaper/home/design_intro${langSuffix}`,
							event: "cta_wallpaper_start",
							category: "cta",
							action: "start_design",
						});
						navigate({ pathname: "/wallpaper/start", search });
					}}
				>
					{t("home.btn")}
				</CampaignButton>
			</Stack>
		</Stack>
	);
}
